import { openFolder } from "@/components/misc";
import { ProjectProps } from "@/interfaces/project_types";
import { useState } from "react";
import { ProjectEditComponent } from "./ProjectEditComponent";


export function ProjectCard({ project, index }: { project: ProjectProps; index: number; }) {
    const [current_text, setCurrentText] = useState(project.description || "");

    return (
        <div key={index} className="grid grid-cols-5 px-2 py-4 hover:bg-slate-100 transition border-b">
            <div className="col-start-2">
                <h5 className="text-blue-500 hover:underline cursor-pointer" onClick={() => openFolder(project.folder_location ?? "")}>
                    {project && project.project_id}
                </h5>
            </div>
            <div>
                {project && project.project_name}
            </div>
            <div>
                {project && project.client_name}
            </div>
            <div>
                <ProjectEditComponent text={current_text} setCurrentText={setCurrentText} project_id={project.project_id || ""} />
            </div>
        </div>
    );
}
